import { DataLineageDiagramUIModel, DataLineageUINode } from '@y42/data-lineage/diagram';
import { DataLineageLink } from '@y42/json-schema';

export const getRefLineage = (itemId: string, fullModel: DataLineageDiagramUIModel): DataLineageDiagramUIModel => {
  const activeGroupNodes = fullModel.nodeDataArray.filter((node) => node.group === itemId);
  if (!activeGroupNodes.length) {
    throw new Error('[Ref Lineage]: No Node Available for the Provided Key.');
  }

  const nodesBucket = new Map<string, DataLineageUINode>();
  const linksBucket: DataLineageLink[] = [];

  const addContainingGroup = (nodeData: DataLineageUINode) => {
    if (nodeData.group) {
      const group = fullModel.nodeDataArray.find(
        (node) => node.key === nodeData.group || node.group === nodeData.group,
      );
      if (group) {
        nodesBucket.set(group.key, group);
      }
    }
  };

  const pickAncestorNodes = (nodeData: DataLineageUINode) => {
    nodesBucket.set(nodeData.key, nodeData);
    if (!nodeData.isGroup) {
      addContainingGroup(nodeData);
    }

    const linksInto = fullModel.linkDataArray.filter((link) => link.to === nodeData.key);
    linksInto.forEach((l) => addToLinkBucket(linksBucket, l));

    const nodesInto = linksInto.map((link) => fullModel.nodeDataArray.find((node) => node.key === link.from));
    nodesInto.forEach((n) => {
      if (n && !nodesBucket.has(n.key)) {
        pickAncestorNodes(n);
      }
    });
  };

  const pickChildrenNodes = (nodeData: DataLineageUINode) => {
    nodesBucket.set(nodeData.key, nodeData);
    if (!nodeData.isGroup) {
      addContainingGroup(nodeData);
    }

    const linksOutOf = fullModel.linkDataArray.filter((link) => link.from === nodeData.key);
    linksOutOf.forEach((l) => addToLinkBucket(linksBucket, l));

    const nodesOutOf = linksOutOf.map((link) => fullModel.nodeDataArray.find((node) => node.key === link.to));
    nodesOutOf.forEach((n) => {
      if (n && !nodesBucket.has(n.key)) {
        pickChildrenNodes(n);
      }
    });
  };

  activeGroupNodes.forEach((activeNode) => {
    pickAncestorNodes(activeNode);
    pickChildrenNodes(activeNode);
  });

  return {
    nodeDataArray: Array.from(nodesBucket.values()),
    linkDataArray: linksBucket,
  } as DataLineageDiagramUIModel;
};

const addToLinkBucket = (bucket: DataLineageLink[], link: DataLineageLink) => {
  if (!bucket.find((l) => l.from === link.from && l.to === link.to)) {
    bucket.push(link);
  }
};
